import coordWeldMapData from "./coordWeldMapData.json";

export const coordWeldMap = (coord: string) => {
  return coordWeldMapData[coord as keyof typeof coordWeldMapData];
};
